import UPLoadingSpinner from './UPLoadingSpinner';

export default UPLoadingSpinner;
